import { Routes, Route } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell.tsx';
import { DashboardRoute } from './routes/DashboardRoute.tsx';
import { DraftsRoute } from './routes/DraftsRoute.tsx';
import { ProjectsListRoute } from './routes/ProjectsListRoute.tsx';
import { ProjectRoute } from './routes/ProjectRoute.tsx';
import { NewMeetingRoute } from './routes/NewMeetingRoute.tsx';
import { EditorRoute } from './routes/EditorRoute.tsx';
import { ArchiveRoute } from './routes/ArchiveRoute.tsx';
import { AdminLayout } from './routes/admin/AdminLayout.tsx';
import { AdminOverview } from './routes/admin/AdminOverview.tsx';
import { AdminUsers } from './routes/admin/AdminUsers.tsx';
import { AdminMeetings } from './routes/admin/AdminMeetings.tsx';
import { AdminProjects } from './routes/admin/AdminProjects.tsx';
import { AdminTeam } from './routes/admin/AdminTeam.tsx';
import { AdminGlossary } from './routes/admin/AdminGlossary.tsx';
import { SignInPage } from './components/SignInPage.tsx';
import { SignedOutPage } from './components/SignedOutPage.tsx';
import { SessionExpiryWatcher } from './components/SessionExpiryWatcher.tsx';
import { useAuth } from './context/AuthContext.tsx';

export function App() {
  const { user, isLoading, justSignedOut } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-sm text-smoke">
        Loading…
      </div>
    );
  }

  if (!user) {
    // Post-signout gets a distinct confirmation screen before looping
    // back to the sign-in prompt. Fresh tabs / direct visits go straight
    // to SignInPage.
    return justSignedOut ? <SignedOutPage /> : <SignInPage />;
  }

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<DashboardRoute />} />
        <Route path="/drafts" element={<DraftsRoute />} />
        <Route path="/projects" element={<ProjectsListRoute />} />
        <Route path="/projects/:id" element={<ProjectRoute />} />
        <Route path="/meetings/new" element={<NewMeetingRoute />} />
        <Route path="/meetings/:id/edit" element={<EditorRoute />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="overview" element={<AdminOverview />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="meetings" element={<AdminMeetings />} />
          <Route path="projects" element={<AdminProjects />} />
          <Route path="team" element={<AdminTeam />} />
          <Route path="glossary" element={<AdminGlossary />} />
          <Route path="archive" element={<ArchiveRoute />} />
        </Route>
      </Routes>
      {/* Sliding-window session renewal + warning banner.
          Reads user.sessionExpiresAt (refreshed every 30 min
          via /me) and renders an amber "ending soon" banner
          when remaining < 30 min. Also redirects to the sign-
          in page on hard expiry instead of letting the next
          mutation 401. */}
      <SessionExpiryWatcher />
    </AppShell>
  );
}
